__turbopack_context__.v({
  "intro": "product-description-module__9Feiga__intro",
  "listIcon": "product-description-module__9Feiga__listIcon",
  "productDescription": "product-description-module__9Feiga__productDescription",
});
